import { normalizeDateYmd, resolveSlotEntryOn } from "helper/packageRotationHelper";

export const frDate = (ymd) => {
  const d = normalizeDateYmd(ymd);
  if (!d) return "—";
  const [y, m, day] = d.split("-");
  return `${day}/${m}/${y}`;
};

export const todayYmd = () => normalizeDateYmd(new Date());

/**
 * Fiche d'édition Sonata d'un forfait (BO Symfony).
 */
export const sonataPackageEditUrl = (packageId) =>
  `${process.env.REACT_APP_API_URL}/e28XmZh3/app/pro-offer-productpackage/${packageId}/edit`;

/**
 * Fiche d'édition Sonata d'un groupe de produits / plateau-repas (BO Symfony).
 */
export const sonataGroupEditUrl = (groupId) =>
  `${process.env.REACT_APP_API_URL}/e28XmZh3/app/pro-offer-productgroup/${groupId}/edit`;

/**
 * Résumé d'un slot : produit du jour + prochaine bascule.
 */
export const slotSummary = (slot) => {
  const today = todayYmd();
  const current = resolveSlotEntryOn(slot, today);
  const next = [...(slot.entries || [])]
    .sort((a, b) => String(a.effective_from || "").localeCompare(String(b.effective_from || "")))
    .find((e) => normalizeDateYmd(e.effective_from) > today);

  return {
    currentName: current?.name || null,
    nextChange: next ? { date: next.effective_from, name: next.name } : null,
  };
};
